import { render, staticRenderFns } from "./OrderTable.vue?vue&type=template&id=ce1aa6ce&scoped=true&"
import script from "./OrderTable.vue?vue&type=script&lang=js&"
export * from "./OrderTable.vue?vue&type=script&lang=js&"
import style0 from "./OrderTable.vue?vue&type=style&index=0&id=ce1aa6ce&scoped=true&lang=css&"
import style1 from "./OrderTable.vue?vue&type=style&index=1&id=ce1aa6ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce1aa6ce",
  null
  
)

export default component.exports